export function createLinkRepository(config) {
    const { repository, client } = config;
    return {
        useLookup(context, props, options) {
            const query = repository.useQuery({
                ...options,
                queryKey: ['link', props],
                async queryFn() {
                    const response = await client.linkCreate({
                        linkCreatePayload: props,
                    }, {});
                    return response.data;
                },
            });
            return query;
        },
    };
}
//# sourceMappingURL=linkRepository.js.map